var _path, _path2, _path3, _path4, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    fill: "none",
    viewBox: "0 0 64 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F7",
    fillRule: "evenodd",
    d: "M0 6c0-3.314 2.686-6 6-6h52c3.314 0 6 2.686 6 6v30c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6V6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8232A",
    fillRule: "evenodd",
    d: "M25 32c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED9F2D",
    fillRule: "evenodd",
    d: "M32 29.486C33.902 31.056 36.34 32 39 32c6.075 0 11-4.925 11-11s-4.925-11-11-11c-2.66 0-5.098.944-7 2.514 2.443 2.018 4 5.07 4 8.486 0 3.416-1.557 6.468-4 8.486z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8232A",
    fillRule: "evenodd",
    d: "M32 12.515c-2.443 2.018-4 5.07-4 8.486 0 3.415 1.557 6.468 4 8.485 2.443-2.017 4-5.07 4-8.485 0-3.416-1.557-6.468-4-8.486z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    width: 8,
    height: 18,
    x: 28,
    y: 12,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 12.515c-2.443 2.018-4 5.07-4 8.486 0 3.415 1.557 6.468 4 8.485 2.443-2.017 4-5.07 4-8.485 0-3.416-1.557-6.468-4-8.486z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED9F2D",
    fillRule: "evenodd",
    d: "M27 13h10v1H27v-1zm0 2h10v1H27v-1zm10 2H27v1h10v-1zm-10 2h10v1H27v-1zm10 2H27v1h10v-1zm-10 2h10v1H27v-1zm10 2H27v1h10v-1zm-10 2h10v1H27v-1zm10 2H27v1h10v-1z",
    clipRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MC.9a88a7b4.svg";
export { ForwardRef as ReactComponent };